import { StyleSheet } from "react-native";

import type { UiTheme } from "../../theme";

// PE-22 K2.3 — the coverage panel's own styles, same makeXStyles(theme)
// recipe as gridStyles.ts / placementMatrixStyles.ts. Token-only: no hex,
// every colour/spacing/size value comes off `theme`.
export function makeCoveragePanelStyles(theme: UiTheme) {
  const { palette: p, spacing: s, typography: t } = theme;
  return StyleSheet.create({
    wrap: { marginTop: s.s4 },
    heading: {
      color: p.ink3,
      fontSize: t.sizes.xs,
      fontWeight: "700",
      letterSpacing: 0.6,
      textTransform: "uppercase",
      marginBottom: s.s2,
    },
    hint: {
      color: p.ink3,
      fontSize: t.sizes.xs,
      lineHeight: t.sizes.xs * t.leading.snug,
      marginBottom: s.s2,
    },
    body: {
      color: p.ink2,
      fontSize: t.sizes.base,
      lineHeight: t.sizes.base * t.leading.snug,
    },
    zero: { color: p.ink3 },
  });
}
